import React, { useState } from "react";
import ScrollToTop from "../Util/ScrollToTop";
// import 'bootstrap/dist/css/bootstrap.min.css';
import { Config } from "./route_config";
import { Route, Routes } from "react-router-dom";
import Home from "../Components/LandingPage/HomePage/home";
import About from "../Components/LandingPage/AboutPage/About";
import { Resource } from "../Components/LandingPage/Resourcess/Resource";
import Blog from "../Components/LandingPage/Blogpage/Blog";
import Contact from "../Components/LandingPage/Contact/Contact";
import Login from "../pages/Login/Login";
import Register from "../pages/Login/Register";
import Forgetpassword from "../pages/Login/Forgetpassword";
import Auth from "../Util/Auth";
import ServicePage from "../Components/LandingPage/ServicePage/ServicePage";
import Readmore from "../Components/LandingPage/ServicePage/Readmore";
import Terms_Conditions from "../Components/Terms_Conditions/Terms_Conditions";
import Privacypolicy from "../Components/Privacypolicy/Privacypolicy";
import Resetpassword from "../pages/Login/Resetpassword";
import Companydetails from "../pages/ComapnyDetails/CompanyDetails";
import Subscribe from "../pages/ComapnyDetails/Subscribe";
import SubscribeSuccessfully from "../pages/ComapnyDetails/SubscribeSuccessfully";
import Mykohere from "../pages/MyKohere/Mykohere";
import SingleResource from "../Components/LandingPage/Resourcess/SingleResource";
import BusinessesforSale from "../Components/LandingPage/BusinessesforSale/BusinessesforSale";
import BusinessescontactForm from "../Components/LandingPage/BusinessesforSale/BusinessescontactForm";
import ContactBusiness from "../Components/LandingPage/BusinessesforSale/ContactBusiness";
import ContactCompany from "../Components/LandingPage/BusinessesforSale/contactCompany";
import Investor_Proposal from "../Components/LandingPage/BusinessesforSale/Investor_Proposal";
import { SingleBlog } from "../Components/LandingPage/Blogpage/SingleBlog";
import SuccessMsg from "../Components/LandingPage/BusinessesforSale/SuccessMsg";
import UpdateTeams from "../pages/MyKohere/UpdateTeams";
import SubscriptionPage from "../pages/ComapnyDetails/subscription_page";
import BusinessSalePagebyid from "../Components/LandingPage/BusinessesforSale/BusinessSalePagebyid";
import DirectorViewPage from "../pages/ComapnyDetails/Directors/Directorviewpage";
import FullCalendarPage from "../Components/LandingPage/HomePage/FullCalendarPage";

// 404 Not Found Component
import NotFound from "../pages/NotFound";
import CancellationPolicy from "../Components/Privacypolicy/CancellationPolicy";

// import Myaccount from '../pages/MyKohere/Myaccount';

function Router() {
  return (
    <div>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services/:name" element={<ServicePage />} />
        <Route path="/kohere/update-teams/:teamId" element={<UpdateTeams />} />
        <Route path="/resources" element={<Resource />} />
        <Route path="/resources/:resourceId" element={<SingleResource />} />
        {/* <Route path='/services/:servicesid' element={<Readmore />} /> */}
        <Route
          path="/services/:servicesid/:servicetitle"
          element={<Readmore />}
        />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:blogId" element={<SingleBlog />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/BusinessesforSale" element={<BusinessesforSale />} />
        {/* <Route path='/BusinessesforSale/BusinessSalePagebyid' element={<BusinessSalePagebyid/>}/> */}
        <Route
          path="/BusinessesforSale/:CIN"
          element={<BusinessSalePagebyid />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/forgetPassword" element={<Forgetpassword />} />
        <Route path="/Resetpassword" element={<Resetpassword />} />
        <Route path="/Terms_Conditions" element={<Terms_Conditions />} />
        <Route path="/cancellationPolicy" element={<CancellationPolicy />} />
        <Route path="/refundPolicy" element={<CancellationPolicy />} />
        <Route path="/Subscribe" element={<Subscribe />} />
        <Route
          path="/SubscribeSuccessfully"
          element={<SubscribeSuccessfully />}
        />
        <Route path="/Privacypolicy" element={<Privacypolicy />} />
        <Route
          path="/kohere/Companydetails/:cin"
          element={<Companydetails />}
        />

        {/* <Route path="/kohere/Companydetails/:cin" element={<CompanyDetails />} /> */}

        <Route
          path="/kohere/Companydetails/:cin/subscribe"
          element={<Companydetails />}
        />
        <Route
          path="/BusinessescontactForm"
          element={<BusinessescontactForm />}
        />
        <Route path="/ContactBusiness/:CIN" element={<ContactBusiness />} />
        <Route path="/SuccessMsg" element={<SuccessMsg />} />
        <Route
          path="/BusinessesforSale/ContactBusiness/contactCompany"
          element={<ContactCompany />}
        />
        <Route
          path="/BusinessesforSale/BusinessescontactForm/Investor_Proposal"
          element={<Investor_Proposal />}
        />
        <Route path="/UpdateTeams" element={<UpdateTeams />} />
        <Route path="/subscription_page" element={<SubscriptionPage />} />
        <Route
          path="/directorviewpage/:cin/:din"
          element={<DirectorViewPage />}
        />
        <Route path="/compliance-calendar" element={<FullCalendarPage />} />

        {/* <Route path="*" element={<NotFound />} /> */}

        {/* <Route path="/Myaccount" element={<Myaccount/>} /> */}

        <Route path="/kohere" element={<Auth />}>
          {Config.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<route.Element />}
            ></Route>
          ))}
        </Route>
      </Routes>
    </div>
  );
}

export default Router;
